import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ProductInfoModel } from '../../../../models/request.model';
import { togglePopup } from '../../../../store/ui';
import { openInNewTab } from '../../../../utils/urls';
import Button, { ButtonSize } from '../button/Button';

const RequestLocation: FC<{ data: ProductInfoModel[]; showLink?: boolean }> = ({ data, showLink }) => {
    const dispatch = useDispatch();
    const intl = useIntl();

    return (
        <Button
            size={ButtonSize.LG}
            onClick={() => {
                showLink && data[0].requestofferbutton.link !== '#REQUEST#'
                    ? openInNewTab(data[0].requestofferbutton.link)
                    : dispatch(togglePopup({ name: 'location_request', status: true, payload: data }));
            }}
        >
            {data[0].requestofferbutton.label
                ? data[0].requestofferbutton.label
                : intl.formatMessage({ id: 'general.requestBtn', defaultMessage: 'Angebot anfragen' })}
        </Button>
    );
};

export default RequestLocation;
